//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    MANUFACTURER_DELETE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    manufacturerDeleteResult,
} from 'Redux/actions';


function* deleteManufacturer({ payload }) {
    try {
        let QUERY = `
            mutation deleteManufacturer ($id: Int) {
                result: deleteManufacturer (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(manufacturerDeleteResult({ delete: data?.result }))
        } else yield put(manufacturerDeleteResult({ error: 'delete-manufacturer' }))

    } catch (exc) {
        yield put(manufacturerDeleteResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/manufacturers/views/.components/deleteManufacturer/redux/saga', 'deleteManufacturer');
    }
}

function* watchManufacturerRequests() {
    yield takeEvery(MANUFACTURER_DELETE_REQUEST, deleteManufacturer);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchManufacturerRequests)
    ]);
}